import {$qsAll} from '../../../../@shared/ts/dom';
import {type LoadingMode} from '../../models/IEnvironment';
import {Carts, DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {store} from '../../store';
import {getLocaleText} from '../../util/translation';

export function setupFreeOrderButton() {
	store.subscribe(() => {
		renderFreeOrderButtonDisplay(
			DefaultCart.contents().length,
			Carts.total(),
			Environment.modalUI.loadingMode(),
		);

		renderFreeOrderButtonLoading(
			Environment.modalUI.loadingMode(),
		);
	});
}

/**
 * Renders the free button display state.
 */
function renderFreeOrderButtonDisplay(cartSize: number, allCartsTotal: number, loadingMode: LoadingMode) {
	// Hide show button container
	if (cartSize > 0 && allCartsTotal === 0) {
		$qsAll('.free-btn-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.free-btn-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Hide/Show button
	if (loadingMode !== 'loading' && allCartsTotal === 0) {
		$qsAll('.free-btn', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.free-btn', $element => {
			$element.classList.add('hide');
		});
	}
}

/**
 * Renders the free button loading state.
 */
function renderFreeOrderButtonLoading(mode: LoadingMode) {
	// Enable/Disable button
	if (mode === 'finished') {
		$qsAll<HTMLInputElement>('.free-btn', $element => {
			$element.disabled = false;
		});
	} else {
		$qsAll<HTMLInputElement>('.free-btn', $element => {
			$element.disabled = true;
		});
	}

	// Show/Hide shipping spinner
	if (mode === 'loading') {
		$qsAll('.pp-btn-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.pp-btn-spinner-container ', $element => {
			$element.classList.add('hide');
		});
	}

	// Add/Remove Processing message + Payment Spinner
	if (mode === 'processing') {
		$qsAll('.free-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Processing');
		});
		$qsAll('.free-btn-spinner', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.free-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Place order');
		});
		$qsAll('.free-btn-spinner', $element => {
			$element.classList.add('hide');
		});
	}
}
